import { CheckSquare, Square } from "lucide-react";

interface FolderSelectionCheckboxProps {
	isSelected: boolean;
}

export const FolderSelectionCheckbox = ({ isSelected }: FolderSelectionCheckboxProps) => {
	return (
		<div className="selection-checkbox">
			{isSelected ? (
				<CheckSquare className="icon-small icon-primary" />
			) : (
				<Square className="icon-small icon-black-80" />
			)}
		</div>
	);
};
